import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ImageSource } from '@app/core/types/common/photo.types';
import { ButtonComponent } from '@app/shared/ui/button/button.component';
import { faCamera, faCloudArrowUp } from '@fortawesome/pro-light-svg-icons';
import { IonicModule } from '@ionic/angular';
import { TranslocoPipe } from '@jsverse/transloco';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'c-photo-option-picker',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, TranslocoPipe, IonicModule, ButtonComponent],
  templateUrl: './photo-option-picker.component.html',
  styleUrls: ['./photo-option-picker.component.scss'],
})
export class PhotoOptionPickerComponent {
  title = 'common.upload';
  description = 'common.preferred-upload';
  faCamera = faCamera;
  faCloudArrowUp = faCloudArrowUp;

  close: (source: ImageSource) => void;

  fromPhotos(): void {
    this.close(ImageSource.Photos);
  }

  takePicture(): void {
    this.close(ImageSource.Camera);
  }
}
